module.exports = __webpack_public_path__ + "img/Support-skill-wave.beb77a18.png";